import React from 'react'

import {
    AllEvents,
    createEditionSelectItemEvent,
    Product,
    WebLink,
} from '@news-mono/web-common'
import {
    StyledEditionImage,
    StyledEditionItem,
    StyledItemDescription,
    StyledItemDetail,
} from './EditionItem.styled'
import { format } from 'date-fns'
import { StyledNightlyEditionListButtonContainer } from '../../SpecificEdition/NightlySpecificEdition.styled'
import { NightlyButton } from '../../../../buttons/NightlyButton/NightlyButton'

export type Edition = {
    id?: string
    title: string
    heading: string
    teaser: string
    publicationDate: string
    link: string
    imageURL: string
    path: string
    lazyloadImages?: boolean
}

export type SpecialEditionItemProps = {
    edition: Edition
    onEvent?: (event: AllEvents) => void
}

export const SpecialEditionItem = ({
    edition,
    onEvent,
}: SpecialEditionItemProps) => {
    const {
        title,
        teaser,
        link,
        imageURL,
        lazyloadImages = false,
        publicationDate,
        path,
        id,
    } = edition
    const handleClick = () => {
        onEvent &&
            onEvent(
                createEditionSelectItemEvent({
                    edition: {
                        id: id,
                        heading: title,
                    },
                    collectionName: 'TheNightlyOn_EditionImage',
                    product: Product.TheNightly,
                    itemDetails: {
                        category: 'thenightly_on_home_page',
                        linkText: `${title} Image`,
                        linkUrl: link,
                    },
                }),
            )
    }

    return (
        <StyledEditionItem>
            {imageURL && (
                <WebLink to={link} onClick={handleClick}>
                    <StyledEditionImage
                        src={imageURL}
                        alt={title}
                        loading={lazyloadImages ? 'lazy' : undefined}
                    />
                </WebLink>
            )}

            <StyledItemDetail>
                <time dateTime={publicationDate}>
                    {format(new Date(publicationDate), 'd MMM yyyy')}
                </time>
                <StyledItemDescription>{teaser}</StyledItemDescription>
                <StyledNightlyEditionListButtonContainer>
                    <NightlyButton
                        variant={'default'}
                        text={'Read Now'}
                        action={{
                            type: 'link',
                            to: link,
                            onClick: () =>
                                onEvent &&
                                onEvent(
                                    createEditionSelectItemEvent({
                                        edition: {
                                            id: id,
                                            heading: title,
                                        },
                                        collectionName:
                                            'TheNightlyOn_ReadNowButton',
                                        product: Product.TheNightly,
                                        itemDetails: {
                                            category: 'thenightly_on_home_page',
                                            linkText: 'Read Now',
                                            linkUrl: link,
                                        },
                                    }),
                                ),
                        }}
                        color={'primary'}
                        fill={'filled'}
                        layout={{
                            shouldGrow: true,
                            alignSelf: 'stretch',
                        }}
                    />
                    <NightlyButton
                        variant={'default'}
                        text={'More Articles'}
                        action={{
                            type: 'link',
                            to: path,
                            onClick: () =>
                                onEvent &&
                                onEvent(
                                    createEditionSelectItemEvent({
                                        edition: {
                                            id: id,
                                            heading: title,
                                        },
                                        collectionName:
                                            'TheNightlyOn_MoreArticlesButton',
                                        product: Product.TheNightly,
                                        itemDetails: {
                                            category: 'thenightly_on_home_page',
                                            linkText: 'More Articles',
                                            linkUrl: path,
                                        },
                                    }),
                                ),
                        }}
                        color={'primary'}
                        fill={'outline'}
                        layout={{
                            shouldGrow: true,
                            alignSelf: 'stretch',
                        }}
                    />
                </StyledNightlyEditionListButtonContainer>
            </StyledItemDetail>
        </StyledEditionItem>
    )
}
